import { log } from "~features/seated-reservation/helpers/stateLogger";
import { showToast } from "~lib";
import { getState } from "../index";
import { unsetSeats } from "./unsetSeats";

export const chartHoldTokenExpired = () => {
  log("chartHoldTokenExpired");

  showToast("Your session has expired, please select new seats.", "error");

  const state = getState();

  // Sometimes this action can fire before chartRendered, such as navigating
  // back to the chart from the checkout. chartRendered should give us a new hold token.
  if (state.chart) {
    void state.chart.startNewSession();
  }

  unsetSeats();
};
